import { useEffect, useState } from 'react';
import api from '@/lib/api';

/**
 * Hook léger pour lire la config IA du tenant courant (assistant_name,
 * tagline, brand_name, etc.). Cached in-memory + rechargé au montage.
 *
 * Défaut Valnexo/Argus si l'API n'est pas encore prête (jamais bloquant UI).
 */
const DEFAULTS = {
    assistant_name: 'Uatu',
    assistant_tagline: "L'Observateur du CRM · Il voit tout, il oublie rien",
    brand_name: 'Valnexo',
    llm_model: 'claude-opus-4-8',
};

let _cache = null;
let _inflight = null;

async function _fetchOnce() {
    if (_inflight) return _inflight;
    _inflight = api.get('/tenant/ai-config')
        .then((res) => {
            _cache = { ...DEFAULTS, ...(res.data || {}) };
            return _cache;
        })
        .catch(() => {
            _cache = DEFAULTS;
            return _cache;
        })
        .finally(() => { _inflight = null; });
    return _inflight;
}

export function invalidateTenantAIConfig() {
    _cache = null;
    _inflight = null;
}

export function useTenantAIConfig() {
    const [cfg, setCfg] = useState(_cache || DEFAULTS);
    useEffect(() => {
        let mounted = true;
        if (!_cache) {
            _fetchOnce().then((c) => { if (mounted) setCfg(c); });
        } else {
            setCfg(_cache);
        }
        return () => { mounted = false; };
    }, []);
    return cfg;
}
